// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--4-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/stylus-loader/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BundleDiscountPillWithTitle.vue?vue&type=style&index=0&id=19dd1715&lang=stylus&scoped=true&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("4448e716", content, true, {});